import React from "react";
import AboutData from './AboutData';
import ProductSpecificationsData from './ProductSpecificationsData';
import MarketingData from './MarketingData';
import PurchasingProcessData from '../Perm/PurchasingProcessData';
import FaqData from '../Perm/FaqData';
import SecurianWL from '../../../../Quoters/Securian/WL/SecurianWL';

export default function JuveData() {
  const minAge = 0;
  const minAgeDays = 14;
  const maxAge = 17;
  const minCoverageAmount = 10000;
  const maxCoverageAmount = 75000;

  return {
    name: "Children's Whole Life Insurance",
    subtitle: "Lifetime Protection Today",
    footerMessage: "Get children's whole life insurance from start to finish completely online.",
    specs: {
      age: { min: minAge, max: maxAge, minAgeDays: minAgeDays },
      coverageAmount: { min: minCoverageAmount, max: maxCoverageAmount }
    },
    basicInfoForm: (history) => {
      return <SecurianWL landing history={history} juvi />
    },
    about: AboutData(),
    productSpecifications: ProductSpecificationsData(minAgeDays, maxAge, minCoverageAmount, maxCoverageAmount),
    marketing: MarketingData(),
    purchasingProcess: PurchasingProcessData(),
    articleKeys: [0, 2, 3],
    faq: FaqData()
  }
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/Juve/JuveData.js